import HttpService from 'domovio-core/src/system/rest/rest.service';
import Config from 'domovio-core/src/system/config';

// SITES
/**
 * @param {Object} data
 * @return {Promise<Any>}
 */
export async function createSite(data) {
    return HttpService.post(Config.SITE_API_DOMAIN + '/v1/sites', data)
}
